import type { PageContextContributor } from '@logz-pkg/models';

// Route resolution for the page-context seam (ORIONIQ-1384).
//
// DELIBERATE SHAPE: a PURE resolver over a caller-supplied list, not a mutable module-level registry. A
// contributor closes over live page state, so it's rebuilt per render by the page's reader hook — registering
// those objects into a global would mean either writing module state during render (concurrent-unsafe) or
// effect-timed registration (a frame where the drawer resolves nothing). Ownership of the list stays in the one
// app-ui hook that builds the contributors; the seam owns matching + collection. Adding a page is still one
// contributor + one line in that list — the send hook never learns a page's name.

/** Drop the app basepath and a leading `/siem` so one matcher serves both `/explore/*` and `/siem/explore/*`. */
export const normalizeContextPathname = (pathname: string): string =>
  pathname.replace(/^\/360/, '').replace(/^\/siem(?=\/|$)/, '');

/** The first contributor whose matcher claims this route; `undefined` on an unknown page (chat still works). */
export const resolvePageContributor = (
  pathname: string,
  contributors: readonly (PageContextContributor | undefined)[],
): PageContextContributor | undefined =>
  contributors.find((contributor): contributor is PageContextContributor =>
    Boolean(contributor?.matchesRoute(pathname)),
  );
